export const prepareSafeInput = (input: string | null) =>
  input ? cleanWhitespaces(input.toLowerCase()) : '';

const cleanWhitespaces = (value: string) => value.replace(/\s/g, '');
